import {Singleton} from 'annotation';
import environment from 'environment';

import ProxyService from './Proxy';
import EntityAware from '../entity/EntityAware';
import Parameter from "./Parameter";
import Response from "./Response";
import AsesmenPendaftar from "../entity/AsesmenPendaftar";
import Authentication from "../Authentication";
import Notification from '../Notification'
import BankSoal from "../entity/BankSoal";
import JawabanBankSoal from "../entity/JawabanBankSoal";
import Constant from "../config/Constant";

@Singleton
export default class BankSoalService extends ProxyService {

    public api: string = environment.BANK_SOAL_API;   // define api url to fetch data

    public serializer: EntityAware = BankSoal;

    public serializerAsesmen: EntityAware = AsesmenPendaftar;

    public serializerJawaban: EntityAware = JawabanBankSoal;

    public findBankSoals(param: any = {}): Promise<any> {
        return this.find(param);
    }

    public findBankSoalById(id: string | number): Promise<any> {
        const parameter = new Parameter()
            .setUrl(`${this.api}/${id}`);

        return this.request(parameter);
    }

    public deleteBankSoal(id: string | number): Promise<any> {
        const parameter = new Parameter()
            .setMethod(Parameter.methods.DELETE)
            .setUrl(`${this.api}/${id}`);

        return this.request(parameter);
    }

    public uploadBankSoal(param: FormData): Promise<any> {
        const parameter = new Parameter(param)
            .setMethod(Parameter.methods.POST)
            .setUrl(`${this.api}/upload`);

        return this.request(parameter);
    }

    public downloadTemplate() {
        return super.downloadFile(
            `${this.api}/template`,
            "Template Upload Bank Soal.xlsx",
            false
        );
    }

    public findJawaban(param: any = {}): Promise<any> {
        const parameter = new Parameter()
            .setUrl(`${this.api}/jawaban`, param);

        return this.request(parameter);
    }

    public findJawabanById(id: string | number): Promise<any> {
        const parameter = new Parameter()
            .setUrl(`${this.api}/jawaban/${id}`);

        return this.request(parameter);
    }

    public deleteJawaban(id: string | number): Promise<any> {
        const parameter = new Parameter()
            .setMethod(Parameter.methods.DELETE)
            .setUrl(`${this.api}/jawaban/${id}`);

        return this.request(parameter);
    }

    public findSoals(pendidikan: string): Promise<any> {
        const parameter = new Parameter().setUrl(this.api + `/soal?pendidikan=${pendidikan}`);
        return this.request(parameter);
    }

    public async doValidate(nomor: string): Promise<boolean> {
        const parameter = new Parameter()
            .setMethod(Parameter.methods.GET)
            .setEnableNotif(false)
            .setUrl(this.api + `/verification?nomor=${nomor}`)
            .serializeData(this.serializerAsesmen);

        return this.request(parameter).then((response: Response) => {
            if (response.isSuccess && response.hasValidData) {
                let data: any = response.getData({});
                Authentication.setAsesmen(data)

                Notification.showNotification({text: "Nomor pendaftar berhasil di validasi", type: 'info'});
                return true;
            }

            Authentication.removeAsesmen();

            if (response.statusResponse !== Constant.STATUS.API.DEFAULT_ERROR) {
                Notification.showNotification({text: 'Nomor pendaftar tidak ditemukan atau tidak valid, Silahkan hubungi admin DimasKHAS'}, true);
            }

            return false;
        });
    }

    public doSendJawaban(param: any): Promise<any> {
        const api: string = this.api + `/jawaban`;
        return this.request(new Parameter(param).setMethod(Parameter.methods.POST).setUrl(api));
    }

    public downloadJawaban(pendidikan: any, tahun: any) {
        return super.downloadFile(this.api + `/jawaban/download?pendidikan=${pendidikan}&tahun=${tahun}`, "Rekap Jawaban Asesmen.xlsx", false);
    }

}
